module.exports = __webpack_public_path__ + "img/treatment.a52bf78a.svg";